import styled from "styled-components";

const CustomiseWrapper = styled.div`
  width: 1264px;
  margin: 10px auto;
  background-color: #fff;
  min-height: 600px;
`

export default CustomiseWrapper;